<template>
  <q-page class="q-px-md q-py-sm">
    <q-form ref="formUserContact">
      <div class="col-12 q-mt-lg">
        <label for="start">Telefone (DDD + número)</label>
        <q-input id="start" v-model="userContatNumber" bg-color="white" class="col-12 q-mt-sm" color="red-9" dense
          outlined mask="(##) #####-####" placeholder="(##) #####-####" unmasked-value :rules="[
            (val) => (val && val.length > 0) || 'Campo Obrigatório',
            (val) => val.length > 10 || 'O número informado não parece valido.',
          ]" lazy-rules />
      </div>
      <div class="col-12 q-mt-lg">
        <label for="start">Login líder</label>
        <q-input  class="col-12 q-mt-sm" id="start" v-model="userLoginData"  color="red-9" dense
          bg-color="white"
          outlined unmasked-value :rules="[
            (val) => (val && val.length > 0) || 'Campo Obrigatório',
          ]" lazy-rules />
      </div>
      <div class="flex row justify-evenly">
        <q-btn class="submit-btn" color="red-9" rounded dense @click="validateuser">Consultar</q-btn>
      </div>
    </q-form>
  </q-page>
</template>

<script>
import { useQuasar } from "quasar";
import { ref } from 'vue';
import { useRouter } from "vue-router";
import { useStore } from "vuex";

import ServiceHistoryServices from "@/services/ServiceHistoryServices";
import ValidateUser from "@/services/ValidateUser.js";
import jwt_decode from "jwt-decode";


export default {
  name: "ActiveUser",
  setup() {
    const validateUser = new ValidateUser();
    const serviceHistoryService = new ServiceHistoryServices();
    const store = useStore();
    const router = useRouter();
    const $q = useQuasar()

    let userContatNumber = ref("")
    let userLoginData = ref("")
    let formUserContact = ref(null)

    const exhistingToken = localStorage.getItem('vega@token');
    let dados_token = jwt_decode(exhistingToken);

    async function validateuser() {
      let isValidade = await formUserContact.value.validate();

      if (isValidade) {
        
        let userLogin = userLoginData.value;
        const exhisitingLogin = dados_token.LoginTecnico;
        
        if(userLogin !== exhisitingLogin) {
          $q.notify({
            message: 'O login informado deve ser o mesmo associado ao seu usuário.',
            color: "red-9",
            position: "top",
            timeout: 3000,
          });
          return;
        };

        const isContactNumberLeader = await serviceHistoryService.checkLeaderLoginRelease(userContatNumber.value);

        if(!isContactNumberLeader){
          $q.notify({
            message: 'O telefone informado não está associado a um líder.',
            color: "red-9",
            position: "top",
            timeout: 3000,
          });
          return;
        };

        let isAlreadyRegistred =  await validateUser.verifyIsLeader(userLogin).then((response) => {
           return response;
         }).catch((err) => {
           $q.notify({
             message: 'Erro ao salvar contato',
             color: "red-9",
             position: "top",
             timeout: 3000,
           });
           router.go(-2);
           return true;
         });
        
         if (isAlreadyRegistred) {
          //  store.commit("setNumberPhone", userContatNumber.value);
           localStorage.setItem('leaderPhone', userContatNumber.value);
           store.commit("setTechnicianLogin", userLoginData.value);
          //  store.commit("setIsLeader", true);
           router.go(-2);

           return;
         }
        
         if(!isAlreadyRegistred) {
           await validateUser.addTechnicanPhone(userLogin, userContatNumber.value).then((response) => {
          //  store.commit("setNumberPhone", userContatNumber.value);
           localStorage.setItem('leaderPhone', userContatNumber.value);

           store.commit("setTechnicianLogin", userLoginData.value);

          //  store.commit("setIsLeader", true);
           $q.notify({
             message: 'Contato salvo com sucesso',
             color: "green-9",
             position: "top",
             timeout: 3000,
           });
           router.go(-2);
         }).catch((err) => {
           $q.notify({
             message: 'Erro ao salvar contato',
             color: "red-9",
             position: "top",
             timeout: 3000,
           });
         });
         }
      }
    }
    
    return {
      //VARIABLES
      userContatNumber,
      formUserContact,
      userLoginData,
      //-----
      //FUNCTIONS
      validateuser
      }
   }
}
</script>

<style scoped lang="scss">
label {
   font-size: 0.75rem;
   font-weight: bold;
   color: #00000061;
}

p {
   font-size: 1rem;
   color: #000000a9;
}

.submit-btn {
   padding: 12px 36px;
}
</style>